// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterTermsAndConditionsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterTermsAndConditionsWebApiHandler_getTermSet,
  CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Path,
  CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms,
} from '@zg-rentals/ts-capps-client';

import type {
  GetTermSetWebApiResponseDto,
  MarkAcceptedTermsWebApiRequestDto,
  MarkAcceptedTermsWebApiResponseDto,
  TermSetId,
} from '@zg-rentals/ts-capps-client';

interface GetTermSetParams {
  termSetId: TermSetId;
}

export type CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Options = UseQueryOptions<
  GetTermSetWebApiResponseDto,
  unknown,
  GetTermSetWebApiResponseDto,
  readonly [string, GetTermSetParams]
>;

const CappsRenterTermsAndConditionsWebApiHandler_getTermSet_GetKey = (getParams: GetTermSetParams) =>
  [CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Path, getParams] as const;

export const CappsRenterTermsAndConditionsWebApiHandler_getTermSet_queryOptions = (
  getParams: GetTermSetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterTermsAndConditionsWebApiHandler_getTermSet_GetKey(getParams),
    queryFn: () => CappsRenterTermsAndConditionsWebApiHandler_getTermSet(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterTermsAndConditionsWebApiHandler_getTermSet = (
  getParams: GetTermSetParams,
  {
    httpClient,
    ...options
  }: Omit<CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRenterTermsAndConditionsWebApiHandler_getTermSet_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsRenterTermsAndConditionsWebApiHandler_getTermSet.getKey =
  CappsRenterTermsAndConditionsWebApiHandler_getTermSet_GetKey;

export interface CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Args {
  postData: MarkAcceptedTermsWebApiRequestDto;
}

export type CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Options = UseMutationOptions<
  MarkAcceptedTermsWebApiResponseDto,
  unknown,
  CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Args
>;

export const useCappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms = ({
  httpClient,
  ...options
}: Omit<CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Args) =>
      CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms(args.postData, httpClient),
  });
};
